/*
 * Copyright (c) 2020. American Express Company
 */

import React, { ReactComponentElement } from 'react';

import { ReactComponent as JessyNeutralIcon } from '../../components/mentors/jessy-neutral.svg';
import BackButton from '../../components/back-button/BackButton';
import BasicDrawer from './common/BasicDrawer';
import PlaidButton from './PlaidButton';
import Typography from '../../components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import './ZeroIncomeDrawer.scss';

export default class ZeroIncomeDrawer extends BasicDrawer<
    any,
    {
        banking: boolean;
        credit: boolean;
        investment: boolean;
        loan: boolean;
    }
> {
    public override state: any = {
        banking: true,
        credit: true,
        investment: true,
        loan: true
    };

    public override render(): ReactComponentElement<any> {
        return (
            <div className="zero-income-drawer drawer">
                <BackButton drawerProps={this.props.drawerProps} handleBack={this.props.handleBack} />
                <Typography variant={TypographyVariants.HEADING_S} className="page-title">
                    Add an Income
                </Typography>
                <PlaidButton
                    handleClearFirstImport={this.props.handleClearFirstImport}
                    handleFirstImport={this.props.handleFirstImport}
                    handleReloadUser={this.props.handleReloadUser}
                    firstImport={this.props.firstImport}
                    setDrawer={this.props.setDrawer}
                    className="plaid-link"
                    user={this.props.user}
                    handleAccounts={this.props.handleAccounts}
                />
                <div className="jessica" key="jessy">
                    <div className="avatar">
                        <JessyNeutralIcon />
                    </div>
                    Looks like you haven't added any incomes yet? Incomes help us predict how things look now and in the
                    future.
                </div>
                <p>Unable to connect your accounts? You can also:</p>
                <p
                    className="link"
                    onClick={() => {
                        this.props.handleAddIncome(this.props.drawerProps.startDate, this.props.drawerProps.endDate);
                    }}
                >
                    Manually enter incomes.
                </p>
            </div>
        );
    }
}
